import React from 'react';

import Togglable from '../togglable';

const mediaIcons = {
	"thirdparty": 	{ "icon": "open_in_browser" },
	"image": 		{ "icon": "image" },
	"audio": 		{ "icon": "volume_up" },
	"document": 	{ "icon": "insert_drive_file" },
	"video": 		{ "icon": "videocam" }
};

const TypeIcon = Togglable(({ type }) => (
	<div className="bg-dark-4 text-white-primary unsw-avatar mr-2">
		<i aria-hidden="true" className="material-icons">{mediaIcons[type].icon}</i>
	</div>
))

export default TypeIcon;